const AU = []

const US = []

const NZ = []

const UK = []

export default { 'en-AU': AU, 'en': US, 'en-NZ': NZ, 'en-GB': UK, 'en-CA': US };
